import * as React from 'react';
import { Link } from 'react-router-dom';
import { routeConstants } from 'app/routes/route-constants';
import { OpenCaseNumber } from 'app/area/startup/components/open-case/open-case';
import styles from './new-case-banner.scss';
import { AiChatAssistant } from 'app/components/ai-chat-assistant/ai-chat-assistant';
import { useState } from 'react';
import { RiArrowLeftSLine } from "react-icons/ri";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";

const RX_REPLACELINK = /\{(.+?)\}/g;

const insertLink = (text: string) => {
  const split = text.split(RX_REPLACELINK);
  return split.map((item, index) => {
    if (!(index % 2)) {
      return item;
    } else {
      return <Link key={index} to={routeConstants.createFavouriteDraft}>{item}</Link>;
    }
  });
};

export interface NewCaseBannerProps {
  textHeader: string;
  textDescription: string;
  textBtnRegisterNewCase: string;
  textOpenCaseHeader: string;
  textOpenCaseDescription: string;
  textCaseNo: string;
  textOpenCase: string;
  aiChatAssistant?: boolean;
}

export const NewCaseBanner = ({
  textHeader,
  textDescription,
  textBtnRegisterNewCase,
  textOpenCaseHeader,
  textOpenCaseDescription,
  textCaseNo,
  textOpenCase,
  aiChatAssistant = false
}: NewCaseBannerProps) => {
  const [isChatActive, setIsChatActive] = useState(false);
  const [isChatCollapsed, setIsChatCollapsed] = useState(false);

  const setChatAssistantActive = () => {
    if (isChatCollapsed) {
      return;
    }
    setIsChatActive(true);
  };

  const handleBackClick = () => {
    setIsChatCollapsed(true);
    setIsChatActive(false);
  };

  const expandChat = () => {
    setIsChatCollapsed(false);
    setIsChatActive(true);
  };

  return (
    <div
      className={`${styles.newCaseBanner}  ${isChatActive ? styles.chatExpanded : ""}`}
    >
      <div className={`row ${styles.newCasePanel}`}>
        <div
          className={`col-md-6 ${styles.newCaseContainer} ${styles.inputToBottom} ${styles.chatCol}`}
        >
          <div>
            <h1>{textHeader}</h1>
            <div className={styles.description}>{textDescription}</div>
            {aiChatAssistant ? (
              <div className={styles.aiChatAssistantContainer}>
                <AiChatAssistant
                  setChatAssistantActive={setChatAssistantActive}
                />
              </div>
            ) : null}
          </div>
          {!aiChatAssistant ? (
            <div>
              <Link
                to={routeConstants.selectCaseType}
                id="register_case"
                className={`btn btn-call-to-action ${styles.btnRegisterNewCase}`}
              >
                {textBtnRegisterNewCase}
              </Link>
            </div>
          ) : null}
          {aiChatAssistant ? (
            <div
              className={
                isChatActive ? styles.aiChatAssistantActive : ""
              }
            >
              <button
                type="button"
                onClick={expandChat}
                className={styles.expandChat}
              >
                <MdOutlineKeyboardArrowRight />
              </button>
            </div>
          ) : null}
        </div>
        <div
          className={`col-md-6 ${styles.inputToBottom} ${styles.openCaseCol}`}
        >
          <div>
            <h2 className={`h1 ${styles.caseNumberTitle}`}>
              {textOpenCaseHeader}
            </h2>
            <div className={`${styles.description} ${isChatActive ? styles.aiChatAssistantActive : ""}`}>
              {insertLink(textOpenCaseDescription)}
            </div>
          </div>
          <div>
            <div
              className={
                isChatActive ? styles.aiChatAssistantActive : ""
              }
            >
              <OpenCaseNumber
                textCaseNo={textCaseNo}
                textOpenCase={textOpenCase}
              />
            </div>
            {aiChatAssistant ? (
              <button
                type="button"
                onClick={handleBackClick}
                className={`${styles.collapseChat} ${!isChatActive ? styles.aiChatAssistantActive : ""}`}
              >
                <RiArrowLeftSLine />
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
